import { combineEpics } from "redux-observable";
import { distinct, filter, map, merge, mergeMap } from "rxjs/operators";

import { actionCreators, isOfAction } from "../actions";
import { getElectronVersion } from "../reducers/electronIntegration";
import { getFitCols, getFitRows, getFlattenRoomViews } from "../reducers/rooms";
import { getRoster, selectMonologRoom } from "../reducers/roster";
import { PersistObject } from "../service/Utils";
import { addBeforeSend } from "../utils/bugsnag";
import { Epic } from "../utils/types";

const onUpdateRoster: Epic = (action$, state$, { App }) => {
    let fromCache = true;
    const sessionCache = new PersistObject("bugsnag_session_cache", {} as {
        deviceId?: string;
        id?: string;
        name?: string;
        email?: string;
    });
    const deviceId =
        sessionCache.value.deviceId ||
        Math.random()
            .toString(36)
            .substring(7);
    if (!sessionCache.value.deviceId) {
        sessionCache.value = { deviceId };
    }
    function fmt(value: string | undefined) {
        return fromCache && value ? "cached-" + value : value;
    }
    addBeforeSend(report => {
        report.user = {
            id: fmt(sessionCache.value.id) || deviceId,
            name: fmt(sessionCache.value.name),
            email: fmt(sessionCache.value.email),
        };
    });
    addBeforeSend(report => {
        const store = App.rootStore.getState();
        const desktopAppVersion = getElectronVersion(store);
        if (desktopAppVersion) {
            report.app.desktopAppVersion = desktopAppVersion;
        }
        report.metaData = {
            roster: {
                count: getRoster(store).size,
            },
            rooms: {
                fitCols: getFitCols(store),
                fitRows: getFitRows(store),
                roomsOpen: getFlattenRoomViews(store).size,
            },
        };
    });

    return action$.pipe(
        filter(isOfAction(actionCreators.onRoster)),
        map(() => selectMonologRoom(state$.value)),
        distinct(),
        mergeMap(monolog => {
            const { userId: id, name, userEmail: email } = monolog || {
                userId: undefined,
                name: undefined,
                userEmail: undefined,
            };
            if (id) {
                fromCache = false;
                sessionCache.value = { ...sessionCache.value, id, name, email };
            }
            return [];
        }),
        merge(
            action$.pipe(
                filter(isOfAction(actionCreators.onLogout)),
                mergeMap(() => {
                    sessionCache.value = { deviceId };
                    return [];
                })
            )
        )
    );
};

export const trackingEpic = combineEpics(
    //
    onUpdateRoster
);
